import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';
import { Box, Stack, Typography } from '@mui/material';

import { ctxTargetAttributes } from '@/contexts/TargetAttributesContext';
import { getMaxTargetNumber } from '@/generated/client/reports/reports';
import { MinimalTarget } from '@/generated/model';
import MultiTargetSelector from '@/components/common/selection/MultiTargetSelector';
import TargetAttributesEditor from './TargetAttributesEditor';

import './TargetAttributes.css';
import i18n from '@/i18n';

export default function TargetAttributesPanel() {
  const [isEditing, setIsEditing] = useState(false);
  const { t } = useTranslation();
  const ctx = useContext(ctxTargetAttributes);
  const selectedTargets = ctx?.selectedTargets; // TODO jo ez igy ????
  const count = selectedTargets?.length ?? 0;

  useEffect(() => {
    async function loadMaxTargetNumber() {
      const localMax = await getMaxTargetNumber();
      ctx?.setMaxTargetNumber(localMax.data);
    }
    void loadMaxTargetNumber();
  }, []);

  if (!ctx) return;

  function GetTargetLabel(
    count: number,
    selectedTargets: MinimalTarget[] | undefined,
    t: TFunction<'translation', undefined>
  ) {
    if (count === 0 || !selectedTargets) return '';
    if (count === 1) return selectedTargets[0].name;
    return t('targetAttributes.vehiclesSelected', { targetCount: count });
  }
  return (
    <div className="targetattributes-container">
      <div className={`targetattributes-target-selector ${isEditing ? 'disabled' : ''}`}>
        <MultiTargetSelector
          selectedTargets={ctx.selectedTargets}
          setSelectedTargets={ctx.setSelectedTargets}
          searchText={ctx.searchText}
          setSearchText={ctx.setSearchText}
          maxElementNumber={ctx.maxTargetNumber}
        />
      </div>
      {count > 0 ? (
        <>
          <div className="targetattributes-editor-container">
            <div>
              <Typography variant="h6" sx={{ color: 'palette.main' }}>
                {t('targetAttributes.title')}{' '}
                {
                  <span className={count > 1 ? 'targetlabel-multiple' : ''}>
                    ({GetTargetLabel(count, selectedTargets, t)})
                  </span>
                }
              </Typography>
              <Typography variant="caption" whiteSpace={'pre-line'}>
                {t('targetAttributes.vehicleSelectedDescription')}
              </Typography>
            </div>
            {/* Azért van a key, hogy nyelváltásnál újra render legyen, ideigenes */}
            <TargetAttributesEditor
              key={i18n.language}
              selectedTargets={selectedTargets}
              onEditingChange={setIsEditing}
            />
          </div>
        </>
      ) : (
        <>
          <Stack gap={4} className="empty-state-container">
            <Box
              className="empty-state-image"
              component="img"
              src="svg/EmptyState_data1_crop.svg"
              alt="not_found"
              data-qa-element-id="no_result_image"
            />
            <Typography
              variant="h6"
              sx={{ textAlign: 'center' }}
              data-qa-element-id="no_result_main_text"
              className="targetattributes-editor-title"
            >
              {t('targetAttributes.emptyStateMainText')}
            </Typography>
            <Typography
              variant="body2"
              sx={{ width: '60%', color: 'text.secondary', textAlign: 'center' }}
              gutterBottom
              data-qa-element-id="no_result_sub_text"
            >
              {t('targetAttributes.emptyStateSubText')}
            </Typography>
            <Typography
              variant="body2"
              className="empty-state-sub-text"
              gutterBottom
              data-qa-element-id="no_result_sub_text"
            >
              {t('targetAttributes.emptyStateSubTextDown')}
            </Typography>
          </Stack>
        </>
      )}
    </div>
  );
}
